import moment from "moment";
import {
  AddingFeedbackInput,
  CampaignHeatsForAsset,
  Conversation,
  Requests,
  Response,
} from "../types/copilot";
import { BaseApi } from "~/services/baseApi";
import { API_URL_COPILOT } from "~/constants/url";
import { CopilotLogRestModel } from "../types/copilotLogs";
import { FeedbackDefinition } from "~/types/feedback";

const copilotRequest = BaseApi({ baseUrl: API_URL_COPILOT });

export const getConversations = async () => {
  const conversations = await copilotRequest<Conversation[]>({
    action: "conversations",
    method: "GET",
  });

  return conversations;
};

export const getRequests = async (conversationId: string, dateISO?: string) => {
  return await copilotRequest<Requests[]>({
    action: "requests",
    method: "GET",
    params: new URLSearchParams({
      conversationId: conversationId,
      date: dateISO || moment().toISOString(),
      size: "3",
    }),
  });
};

export const getRequestsForHeat = async (campaignHeatId: string) => {
  return await copilotRequest<Requests[]>({
    action: "requestsForHeat",
    method: "GET",
    params: new URLSearchParams({
      campaignHeatId,
    }),
  });
};

export const getCampaignHeatsForAsset = async (assetId: string) => {
  return await copilotRequest<CampaignHeatsForAsset[]>({
    action: "campaignHeatsForAsset",
    method: "GET",
    params: new URLSearchParams({
      assetId,
    }),
  });
};

export const saveLogs = async (logs: CopilotLogRestModel) => {
  return await copilotRequest({
    action: "logs",
    method: "POST",
    body: JSON.stringify(logs),
  });
};

export const requestsByIds = async (ids: string[]) => {
  return await copilotRequest<Requests[]>({
    action: "requestsByIds",
    method: "POST",
    body: JSON.stringify(ids),
  });
};

export const addFeedback = async (input: AddingFeedbackInput) => {
  return await copilotRequest({
    action: "feedback",
    method: "POST",
    body: JSON.stringify(input),
  });
};

export const getFeedbackDefinitions = async () => {
  return await copilotRequest<FeedbackDefinition[]>({
    action: "feedbackDefinitions",
    method: "GET",
  });
};

// New service for getting conversation by responseId
export const getConversationByResponseId = async (responseId: string) => {
  return await copilotRequest<Conversation>({
    action: `ConversationByResponseId/${responseId}`,
    method: "GET",
  });
};

// New service for getting response details by responseId
export const getResponseById = async (responseId: string) => {
  return await copilotRequest<Response>({
    action: `Response/${responseId}`,
    method: "GET",
  });
};
